export default __webpack_public_path__ + "static/media/003-video game controller.e4f4c630.svg";